import camelCase from 'lodash/camelCase';
import { getSuffix } from './apiKeys';

const labels = {
  electric_vehicle: 'Purchase electric vehicle',
  hybrid_vehicle: 'Purchase hybrid vehicle',
  alternativefuel_vehicle: 'Purchase alternative fuel vehicle',
  more_efficient_vehicle: 'More efficient vehicle',
  telecommute_to_work: 'Telecommute to work',
  practice_eco_driving: 'Practice eco driving',
  carpool_to_work: 'Carpool to work',
  maintain_my_vehicles: 'Maintain my vehicles',
  ride_my_bike: 'Ride my bike',
  take_public_transportation: 'Take public transportation',
  reduce_air_travel: 'Reduce air travel',
  switch_to_cfl: 'Switch to CFLs or LEDs',
  turn_off_lights: 'Turn off lights',
  T12toT8: 'Switch from T12 Lights to T8 Lights',
  tankless_water_heater: 'Purchase tankless water heater',
  thermostat_winter: 'Reduce winter household thermostat',
  thermostat_summer: 'Increase summer household thermostat',
  purchase_high_efficiency_cooling: 'Purchase high efficiency cooling',
  purchase_high_efficiency_heating: 'Purchase high efficiency heating',
  energy_star_fridge: 'Replace refrigerator with Energy Star refrigerator',
  energy_star_printers: 'Replace printers with Energy Star printers',
  energy_star_copiers: 'Replace copiers with Energy Star copiers',
  energy_star_desktops: 'Replace computers with Energy Star computers',
  rechargeable_batteries: 'Use rechargeable batteries',
  power_mgmt_comp: 'Manage computer energy use',
  purchase_green_electricity: 'Purchase green electricity',
  install_PV_panels: 'Install PV panels',
  install_solar_heating: 'Install solar water heater',
  low_flow_showerheads: 'Install low flow showerheads',
  low_flow_faucets: 'Install low flow faucets',
  low_flow_toilet: 'Install low flow toilets',
  line_dry_clothing: 'Line dry clothing',
  water_efficient_landscaping: 'Install water efficient landscaping',
  plant_trees: 'Plant trees',
  reduce_comm_waste: 'Reduce my waste',
  print_double_sided: 'Print double sided',
  low_carbon_diet: 'Eat a low carbon diet',
  go_organic: 'Go organic',
};

const getLabel = (apiKey, t) => {
  const actionSuffix = getSuffix(apiKey);
  const label = labels[actionSuffix];
  return t(label, { ns: camelCase(actionSuffix) });
};

export default {
  getLabel,
};
